import mountOptionPicker from './optionPicker';
import {
    IOptionPickerImageItem,
} from '@vfde-brix-ws10/option-picker';

 /**
  * Mount Image Option Picker
  * @param container
  * @param id
  * @param items
  * @param onChangeAction
  */
export const mountImageOptionPicker = (container: HTMLElement, id: string, items: IOptionPickerImageItem[], onChangeAction?: (value: string) => void) => {

    return mountOptionPicker(container, id, 'image', items, onChangeAction);
};
